import { render, staticRenderFns } from "./candidates-status-icon.vue?vue&type=template&id=80847238&scoped=true&"
import script from "./candidates-status-icon.vue?vue&type=script&lang=js&"
export * from "./candidates-status-icon.vue?vue&type=script&lang=js&"
import style0 from "./candidates-status-icon.vue?vue&type=style&index=0&id=80847238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80847238",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80847238')) {
      api.createRecord('80847238', component.options)
    } else {
      api.reload('80847238', component.options)
    }
    module.hot.accept("./candidates-status-icon.vue?vue&type=template&id=80847238&scoped=true&", function () {
      api.rerender('80847238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/staff/candidates/components/candidates-status-icon.vue"
export default component.exports